module.exports = __webpack_public_path__ + "static/media/banner.bfe9e915.png";